module.exports = __webpack_public_path__ + "static/img/trade-icon2.b144459.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trade-icon2.png
// module id = seH6
// module chunks = 0